"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getInspirationContentSource;

function getInspirationContentSource() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      assetId = _ref.assetId,
      embedCode = _ref.embedCode;

  if (!assetId && !embedCode) {
    return 'N/A';
  }

  return embedCode ? 'Video Embed' : 'Video';
}